import { createStore, compose, applyMiddleware } from "redux"

export default function setupReduxStore(rootReducer, initialState = {}, ...middleware) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  window.store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)))
  return window.store
}
